import _ from 'lodash'
import {
  cachedConnect as connect,
} from './helpersHOC'
import JobRun from '../components/JobRun'

// import { normalizeMinions } from '../saltapi/commonUtils'

export default connect(
  (state, ownProps, {cachedState}) => {
    let {
      _docs:docs, _minions,
      clients
    } = state.api
    let minions = _minions.status
    if (_.size(cachedState.docs) !== _.size(docs) ||
        _.size((cachedState.docs||{}).functions) !== _.size((docs||{}).functions) ||
        _.size((cachedState.docs||{}).runners) !== _.size((docs||{}).runners) ||
        _.size(cachedState.minions) !== _.size(minions) ||
        _.size(cachedState.availableClients) !== _.size(clients) )
      cachedState = {
        ...cachedState,
        docs,
        minions,
        availableClients: clients
      }
    console.log('JobRun', cachedState)
    return cachedState
  })(JobRun)



// WEBPACK FOOTER //
// ./src/containers/JobRun.js